import React from "react";
import { Icon, IconButton, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FieldArray } from "formik";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";

export default function DevedorEmailSection({ values, setFieldValue, handleChange, errors, touched, isViewOnly }) {
    return (
        <MDBox mt={2}>
            <FieldArray name="emails">
                {({ push, remove }) => (
                    <>
                        <MDBox display="flex" justifyContent="flex-end" mb={1}>
                            <MDButton variant="contained" color="info" size="small" onClick={() => push({ ccEmail: '', cvOrigem: 1, cbRuim: false, cbBlackList: false })}>
                                <Icon sx={{ mr: 0.5 }}>add</Icon> Adicionar E-mail
                            </MDButton>
                        </MDBox>
                        {values.emails.length > 0 && (
                            <TableContainer sx={{ boxShadow: "none" }}>
                                <Table>
                                    <MDBox component="thead">
                                        <TableRow>
                                            <DataTableHeadCell width="45%" sorted={false}>E-mail</DataTableHeadCell>
                                            <DataTableHeadCell width="20%" sorted={false}>Origem</DataTableHeadCell>
                                            <DataTableHeadCell width="11%" align="center" sorted={false}>Ruim</DataTableHeadCell>
                                            <DataTableHeadCell width="11%" align="center" sorted={false}>Blacklist</DataTableHeadCell>
                                            <DataTableHeadCell width="13%" align="center" sorted={false}>Ações</DataTableHeadCell>
                                        </TableRow>
                                    </MDBox>
                                    <TableBody>
                                        {values.emails.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <MDInput 
                                                        fullWidth 
                                                        size="small"
                                                        name={`emails[${index}].ccEmail`}
                                                        value={values.emails[index].ccEmail} 
                                                        onChange={handleChange} 
                                                        placeholder="exemplo@email.com"
                                                        autoComplete="off"
                                                        error={errors?.emails?.[index]?.ccEmail && touched?.emails?.[index]?.ccEmail}
                                                    />
                                                    {errors?.emails?.[index]?.ccEmail && touched?.emails?.[index]?.ccEmail && (
                                                        <MDTypography variant="caption" color="error">{errors.emails[index].ccEmail}</MDTypography>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <MDInput 
                                                        select 
                                                        fullWidth 
                                                        size="small"
                                                        name={`emails[${index}].cvOrigem`}
                                                        value={values.emails[index].cvOrigem} 
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem value={1}>Serasa</MenuItem>
                                                        <MenuItem value={2}>Boa Vista</MenuItem>
                                                        <MenuItem value={3}>Cliente</MenuItem>
                                                        <MenuItem value={4}>Informado</MenuItem>
                                                        <MenuItem value={5}>Outros</MenuItem>
                                                        <MenuItem value={6}>Remessa</MenuItem>
                                                    </MDInput>
                                                </TableCell>
                                                <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <Switch 
                                                        checked={values.emails[index].cbRuim} 
                                                        onChange={(e) => setFieldValue(`emails[${index}].cbRuim`, e.target.checked)} 
                                                    />
                                                </TableCell>
                                                <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <Switch 
                                                        checked={values.emails[index].cbBlackList} 
                                                        onChange={(e) => setFieldValue(`emails[${index}].cbBlackList`, e.target.checked)} 
                                                        color="error" 
                                                    />
                                                </TableCell>
                                                <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <IconButton color="error" size="small" onClick={() => remove(index)}>
                                                        <Icon>delete</Icon>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </>
                )}
            </FieldArray>
        </MDBox>
    );
}
